<template>
  <div class="carousel_wrap">
    <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <h2 style="color:#666">ESOO-PARK</h2>
          <h4 style="width: 47%;padding: 14px 0;font-weight: 500;color:#212121;">{{ item.line2 }}</h4>
          <el-button @click="$router.push({name:'demo'})" size="medium" type="primary" style="    width: auto;font-size: 16px;" round>预约产品演示</el-button>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <h1>{{ item.line2 }}</h1>
        </div>
      </el-carousel-item>
    </el-carousel> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          src: require('@/assets/img/banner3.png'),
          line1: '智慧园区管理平台',
          line2: '赋能园区数字化转型,覆盖产业园区、工业园区、商业办公楼、综合园区等多个领域',
        },
        // {
        //   src: require('@/assets/img/banner4.png'),
        //   line1: '全面推进数字建设化改革',
        //   line2: '',
        // },
      ],
    }
  },
}
</script>

<style lang="scss">
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      background: linear-gradient(62deg, rgba(0, 128, 255, 0.14) 0%, rgba(87, 6, 165, 0.02) 100%);
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #3d3d3d;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
</style>